import { useQuery } from '@tanstack/react-query';

import { TgManager } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getManagers = (params: { pageId: string }): Promise<{ managers: TgManager[] }> => {
  return axios.get(`/managers`, { params });
};

type QueryFnType = typeof getManagers;

type UseGetManagers = {
  pageId: string;
  config?: QueryConfig<QueryFnType>;
};

export const useGetManagers = ({ pageId, config = {} }: UseGetManagers) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['managers', pageId],
    queryFn: () => getManagers({ pageId }),
  });
};
